var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useContext } from 'react';
import { DownloadDataContext } from '../DownloadContexts';
export const useDownloadData = () => {
    _react_refresh_temp_1();
    const downloadValue = useContext(DownloadDataContext);
    if (!downloadValue) {
        throw new Error('DownloadData context not found. You are trying to access the context from a component above the provider in the components tree');
    }
    return downloadValue;
};
_react_refresh_temp_1(useDownloadData, "zVOwEi6GWXs56bSaLcseTzlVRRo=");
